import React, { useState, useEffect } from "react";
import {
	Box,
	Typography,
	IconButton,
	Menu,
	MenuItem,
	useTheme,
	Tooltip,
	Snackbar,
	Alert,
	CircularProgress,
	Backdrop,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";

//user import

import { useDecodedToken } from "../Services/Routes/APP/PrivateRoute";
import { COMMON_API_URLS } from "../Services/Routes/API";
import DetailsIcon from "../Svg/DetailIcon";
import BellIcon from "../Svg/BellIcon";
import AlertBallIcon from "../Svg/AlertBallIcon";
import { headersGet, headersUpdate } from "../Services/API";
import { commonRoutes } from "../Services/Routes/APP";

// styling

const useStyles = makeStyles({
	hiddenScrollBar: {
		padding: "1rem",
		overflowY: "scroll",
		"-ms-overflow-style": "none",
		scrollbarWidth: "none",
		"&::-webkit-scrollbar": {
			display: "none",
		},
	},
	notificationDropdownBox: {
		"& .MuiPaper-root": {
			height: "fit-content",
			maxHeight: "50%",
			padding: "5%, 15%",
			borderRadius: 5,

			width: "27%",
			"@media (max-width: 960px)": {
				width: "35%",
			},
			"@media (max-width: 780px)": {
				width: "40%",
			},
			"@media (max-width: 660px)": {
				width: "50%",
			},
			"@media (max-width: 480px)": {
				width: "60%",
			},

			overflowY: "scroll",
			"-ms-overflow-style": "none",
			scrollbarWidth: "none",
			"&::-webkit-scrollbar": {
				display: "none",
			},
		},
	},
	notificationListItem: {
		whiteSpace: "break-spaces",
		margin: "0.5em",
		padding: 0,
	},
	notificationText: {
		fontSize: "0.8rem",
		lineHeight: 1,
	},
});

const NotificationPanel = ({
	cableConnectionStatus,
	newNotification,
	clearNewNotification,
}) => {
	const location = useLocation();
	const navigate = useNavigate();
	const user = useDecodedToken();

	const [alertOpen, setAlertOpen] = useState(false);
	const [alertMsg, setAlertMsg] = useState("");
	const [alertIcon, setAlertIcon] = useState("error");
	const [loaderOpen, setLoaderOpen] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);

	const [notificationsList, setNotificationsList] = useState([]);
	const [notificationSeen, setNotificationSeen] = useState(true);
	const [notificationIdsListToUpdateSeen, setNotificationIdsListToUpdateSeen] =
		useState([]);
	const [
		triggeredToUpdateNotificationSeen,
		setTriggeredToUpdateNotificationSeen,
	] = useState(false);

	const theme = useTheme();

	const handleDropdownTriggerClick = (event) => {
		const newDropdownEl = event.currentTarget;
		if (newDropdownEl?.id === "notification-dropdown-trigger") {
			// updateNotificationsSeenStatus();
		}
		setAnchorEl(newDropdownEl);
	};
	const updateNotificationsSeenStatus = (notifications_to_update) => {
		if (notifications_to_update) {
			const data = {
				notification_ids: notifications_to_update.map((notif) => notif?.id),
			};
			if (data.notification_ids?.length > 0) {
				headersUpdate(COMMON_API_URLS.UPDATE_NOTIFICATION_STATUS, data).then(
					(res) => {
						if (res?.status === 200 && res?.data?.success) {
							const toUpdateNotificationIdsList =
								res?.data?.notification_ids_to_update;
							if (toUpdateNotificationIdsList?.length > 0) {
								setNotificationIdsListToUpdateSeen(toUpdateNotificationIdsList);
							} else {
								setTriggeredToUpdateNotificationSeen(false);
							}
						}
					}
				);
			} else {
				setTriggeredToUpdateNotificationSeen(false);
			}
		}
	};

	const handleDropdownClose = () => {
		setAnchorEl(null);
	};

	const getNotifications = () => {
		headersGet(COMMON_API_URLS.GET_NOTIFICATIONS).then((res) => {
			if (res?.status === 200 && res?.data?.success) {
				
				setNotificationsList(res?.data?.received_notifications);
			}
		});
	};

	useEffect(() => {
		if (newNotification) {
			if (
				newNotification !== notificationsList[notificationsList?.length - 1]
			) {
				setNotificationsList((prevList) => [newNotification, ...prevList]);
			}
			clearNewNotification(newNotification);
		}
	}, [newNotification]);

	const updateNotificationIconSeenStatus = () => {
		if (
			notificationsList?.filter((notif) => notif?.seen === false)?.length > 0
		) {
			setNotificationSeen(false);
		} else if (!notificationSeen) {
			setNotificationSeen(true);
		}
	};

	useEffect(() => {
		if (notificationsList?.length > 0) {
			updateNotificationIconSeenStatus();
		}
	}, [notificationsList]);

	useEffect(() => {
		if (
			notificationIdsListToUpdateSeen?.length > 0 &&
			triggeredToUpdateNotificationSeen
		) {
			if (notificationsList?.length > 0) {
				let newList = notificationsList;
				newList = newList?.reduce((resultingArray, not) => {
					let obj = not;
					if (notificationIdsListToUpdateSeen?.includes(not.id)) {
						obj.seen = true;
					}
					return (resultingArray = [...resultingArray, obj]);
				}, []);
				setNotificationsList(newList);
				setNotificationIdsListToUpdateSeen([]);
				setTriggeredToUpdateNotificationSeen(false);
			}
		}
		if (notificationsList?.length > 0) {
			updateNotificationIconSeenStatus();
		}
	}, [notificationIdsListToUpdateSeen, triggeredToUpdateNotificationSeen]);

	useEffect(() => {
		if (
			cableConnectionStatus?.initializing &&
			cableConnectionStatus?.disconnected
		) {
			setAlertOpen(true);
			setAlertMsg("Live notifications needs a page reload to work properly!");
			setAlertIcon("error");
		}
	}, [cableConnectionStatus]);

	useEffect(() => {
		getNotifications();
	}, []);

	const classes = useStyles();

	return (
		<>
			<Tooltip
				title={
					cableConnectionStatus?.initializing &&
					cableConnectionStatus?.disconnected
						? "Reload the page!"
						: ""
				}
			>
				<Box
					id={"notification-dropdown-trigger"}
					m={"auto 0.5rem"}
					height={"40px"}
					width={"40px"}
					padding={0}
					component={IconButton}
					onClick={handleDropdownTriggerClick}
				>
					<BellIcon
						sx={{ margin: "auto" }}
						errorColor={
							cableConnectionStatus?.initializing ||
							(cableConnectionStatus?.initializing &&
								cableConnectionStatus?.disconnected)
								? theme.palette.error.light
								: null
						}
						seen={notificationSeen}
					/>
				</Box>
			</Tooltip>
			<Menu
				id={"notification-dropdown-ul"}
				anchorEl={
					anchorEl?.id === "notification-dropdown-trigger" ? anchorEl : null
				}
				open={anchorEl?.id === "notification-dropdown-trigger"}
				onClose={() => {
					handleDropdownClose();
					// setTriggeredToUpdateNotificationSeen(true);
				}}
				onClick={handleDropdownClose}
				className={`${classes?.notificationDropdownBox} ${classes?.hiddenScrollBar}`}
				transformOrigin={{ horizontal: "right", vertical: "top" }}
				anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
			>
				{notificationsList?.length > 0 ? (
					notificationsList?.map((notifi, index) => {
						let notificationColor = "";
						switch (notifi?.category) {
							case "success":
								notificationColor = theme?.palette?.success?.main;
								break;
							case "error":
								notificationColor = theme?.palette?.error?.main;
								break;
							default:
								notificationColor = theme?.palette?.grey?.[600];
								break;
						}

						return (
							<MenuItem
								key={`${notifi?.message}-notification-${index}`}
								className={`${classes?.notificationListItem}`}
								onClick={() => {
									setTriggeredToUpdateNotificationSeen(true);
									updateNotificationsSeenStatus([notifi]);
									
									if (notifi?.subject_type) {
										navigate(notifi?.subject_type + commonRoutes?.details, {
											state: {
												
												detailsType: notifi?.subject_type,
												detailsData: notifi?.subject ,
											},
										
										});
									}
								}}
							>
								<Box
									display={"flex"}
									alignItems={"center"}
									width={"100%"}
									margin={"0.25em 1em"}
								>
									<AlertBallIcon top={5} right={5} show={!notifi?.seen} />
									<Box display={"flex"} alignItems={"center"}>
										<DetailsIcon size={25} color={notificationColor} />
									</Box>
									<Typography
										ml={1}
										className={`${classes?.notificationText}`}
										color={notificationColor}
									>
										{notifi?.message}
									</Typography>
								</Box>
							</MenuItem>
						);
					})
				) : (
					<MenuItem className={`${classes?.notificationListItem}`}>
						<Box
							display={"flex"}
							alignItems={"center"}
							width={"100%"}
							justifyContent={"center"}
						>
							<Typography
								ml={1}
								className={`${classes?.notificationText}`}
								color={theme?.palette?.grey?.[600]}
							>
								{"No notifications!"}
							</Typography>
						</Box>
					</MenuItem>
				)}
			</Menu>
		</>
	);
};

export default NotificationPanel;
